import * as React from 'react';
import './index.css';
export default function PaymentPlateHead(props) {
    var paymentCompanyData = props.paymentCompanyData;
    return (React.createElement("div", { className: 'payment_plate_company_box' },
        React.createElement("div", { className: 'payment_plate_company_name' }, "\u6536\u6B3E\u5355\u4F4D"),
        React.createElement("div", { className: 'payment_plate_company_title_box' },
            React.createElement("div", { className: 'payment_plate_company_title' }, "\u6536\u5165\u673A\u5173"),
            React.createElement("div", { className: 'payment_plate_company_title', style: { letterSpacing: '24px' } }, "\u79D1\u76EE"),
            React.createElement("div", { className: 'payment_plate_company_title' }, "\u6536\u6B3E\u56FD\u5E93")),
        React.createElement("div", { className: 'payment_plate_company_content_box', style: { width: '403px' } },
            React.createElement("div", { className: 'payment_plate_company_content' }, paymentCompanyData.incomeCompany),
            React.createElement("div", { className: 'payment_plate_company_contents' },
                React.createElement("div", { className: 'payment_plate_company_conten_i' }, paymentCompanyData.subject),
                React.createElement("div", { className: 'payment_plate_company_conten_i', style: {
                        'width': '99px',
                        borderRight: '1px solid #DBDDDF',
                        borderLeft: '1px solid #DBDDDF',
                    } }, "\u9884\u7B97\u6B21\u7EA7"),
                React.createElement("div", { className: 'payment_plate_company_conten_i' }, paymentCompanyData.subbudget)),
            React.createElement("div", { className: 'payment_plate_company_content' }, paymentCompanyData.collectionBank)),
        React.createElement("div", { className: 'payment_plate_company_name', style: {
                writingMode: 'vertical-rl',
                lineHeight: '12px',
                letterSpacing: '4px'
            } }, "\u4EA4\u6B3E\u5355\u4F4D(\u4EBA)"),
        React.createElement("div", { className: 'payment_plate_company_title_box' },
            React.createElement("div", { className: 'payment_plate_company_title', style: { letterSpacing: '24px' } }, "\u540D\u79F0"),
            React.createElement("div", { className: 'payment_plate_company_title', style: { letterSpacing: '24px' } }, "\u8D26\u53F7"),
            React.createElement("div", { className: 'payment_plate_company_title' }, "\u5F00\u6237\u94F6\u884C")),
        React.createElement("div", { className: 'payment_plate_company_content_box', style: { flex: 1, borderRight: '0px' } },
            React.createElement("div", { className: 'payment_plate_company_content' }, paymentCompanyData.paymentName),
            React.createElement("div", { className: 'payment_plate_company_content' }, paymentCompanyData.paymentNumber),
            React.createElement("div", { className: 'payment_plate_company_content' }, paymentCompanyData.paymentBanck))));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-invoice-plate/PaymentPlate/PaymentPlateCompany/index.js
// module id = 4241
// module chunks = 0